import { Box, Button, Heading, HStack, Icon, Image, Spacer, Text,Radio, RadioGroup, Stack } from '@chakra-ui/react'
import React, { useContext, useEffect, useState } from 'react'
import { xenditPayment } from '../Api/payment'
import AuthContext from '../Routes/hooks/AuthContext'
import { AiOutlinePlusCircle ,AiOutlineMinusCircle,AiOutlineDelete} from 'react-icons/ai'
import { doc, setDoc } from 'firebase/firestore'
import { db } from '../Config/firebase'
import _ from 'lodash'

function CartPage() {
	const [totalPrice,setTotalPrice]=useState(0)
	const { cartList,currentUser } = useContext(AuthContext)
	const [bank,setBank]=useState()
	const [loading,setLoading]=useState(false)

	const countTotal=()=>{
		console.log(_.isEmpty(cartList))
		if(_.isEmpty(cartList)){setTotalPrice(0)}
		else{
			let total=0
			cartList.products.map((x)=>total+= x.price*x.qty)
			setTotalPrice(total) 

		}
	}



	const handleFirebase = async(data)=>{
		 await setDoc(doc(db, "cart", currentUser.uid), data)
	}

	const handleMinus=async(i)=>{
		const data = cartList
		if(data.products[i].qty-1>0){
			const newQty=data.products[i].qty-1
			data.products[i].qty=newQty
		}
		else{
			data.products.splice(i, 1)
		}
		await handleFirebase(data)
	}

	const handleAdd=async(i)=>{
		const data = cartList
			const newQty=data.products[i].qty+1
			data.products[i].qty=newQty
		await handleFirebase(data)

	}

	const handleDelete=async(i)=>{
		const data = cartList
		data.products.splice(i, 1)
		await handleFirebase(data)
	}

	const handlePayment=async()=>{
		setLoading(true)
		const res = await xenditPayment(cartList,totalPrice,currentUser.uid,bank);
		console.log(res.data,'ini di handle payment')
		
		setLoading(false)
	}

	useEffect(() => {
		countTotal()
	  return () => {
		
	  }
	}, [cartList])
	
	return (
	<>
	<Heading>Keranjang</Heading>
	{cartList?.products?
	cartList.products.map((x,i)=><>
	<Box key={i}> 
	<HStack>

		<Image p='1' src={x.image} width='36' alt={x.name}/>
		<Box>
			<Text>{x.name}</Text>
			<Text>IDR {Intl.NumberFormat('en-ID',{maximumSignificantDigits: 3}).format(x.price)}</Text>
		</Box>
		<Spacer/>
		<HStack p='2'>
			<Icon as={AiOutlineMinusCircle} color='red' cursor='pointer' onClick={()=> handleMinus(i)}/>
			<Text>{x.qty}</Text>
			<Icon as={AiOutlinePlusCircle} color='green' cursor='pointer'  onClick={()=> handleAdd(i)}/>
			<Icon as={AiOutlineDelete} color='red' cursor='pointer'  onClick={()=> handleDelete(i)}/>

		</HStack>
	</HStack>
	</Box>

	</>)
	:
	<Text>No product in Cart</Text>}	
	
	{totalPrice>0?<>
		<RadioGroup onChange={setBank} value={bank}>
      <Stack direction='column'>
        <Radio value='BRI'>BRI Virtual Account</Radio>
        <Radio value='BNI'>BNI Virtual Account</Radio>
        <Radio value='MANDIRI'>MANDIRI Virtual Account</Radio>
      </Stack>
    </RadioGroup>
	<HStack>
		<Spacer/>
		<HStack>
			<Text>Total</Text>
			<Heading>IDR {totalPrice?Intl.NumberFormat('en-ID',{maximumSignificantDigits: 3}).format(totalPrice):0}</Heading>
		</HStack>
	</HStack>

	{bank&&loading===false?<Button colorScheme='blue' onClick={()=>handlePayment()}>Bayar</Button>:<></>}
	</>
	:<></>}
	</>
  )
}

export default CartPage